import React, { Component } from "react";
// import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

//Miscellaneous 
// import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { Icon } from "@iconify/react";

//Components 
import QuickPay from "./QuickPay";
import BankTransfer from "./BankTransfer";
import EWallet from "./EWallet";
import Crypto from "./Crypto";
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";
import MobileImportantNotice from "../../components/MobileImportantNotice/MobileImportantNotice";

class MobileDeposit extends Component {
    constructor(props) {
        super(props);
        this.state =
        {
            // showNotice: false,
            showNum: false,
        }
    }

    shouldComponentUpdate() {
        return true;
    }

    toggleNoticeHandler = () => {
        if (this.state.showNotice === false) {
            document.body.classList.add('modal-open');
        }
        else {
            document.body.classList.remove('modal-open');
        }

        this.setState({
            showNotice: !this.state.showNotice,
        });
    }

    onInputChangeHandler = (event) => 
	{
        // console.log(event.target.name+' | '+event.target.value)
		if (event.target.name === 'showNum') 
        {
            this.setState({
                showNum: !this.state.showNum,
                errorMsg: [],
                formError: false,
                converted_currency: "",
                converted_amount: "",
            });
        }
        else 
        {
            this.setState({
                [event.target.name]: event.target.value,
                errorMsg: [],
                formError: false,
                converted_currency: "",
                converted_amount: ""
            });
        }

        if(event.target.name === 'amount'){
            if(this.state.memberId !== null && this.state.memberId !== "" && this.state.memberId !== undefined && event.target.value > 0){
                let data = {};
                data.member_id = this.state.memberId;
                data.amount = event.target.value;
                this.props.getCurrencyExchange(data);
            }
        }
	}

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    render() {
        const { t } = this.props;
        const icons = this.imageImport(require.context("../../assets/images/deposit/icons", false, /\.(png|jpe?g|svg)$/));
        const walletImg = this.imageImport(require.context("../../assets/images/deposit/icons", false, /\.(png|jpe?g|svg)$/));
        const img = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        let date = new Date();
        let wallet = 0.0;
        if (!this.props.loading) {
            wallet = this.props.data;
        }
        return (
            <Auxiliary>
                {/* {this.state.showNotice &&
                    <MobileImportantNotice
                        notice="deposit"
                        toggleNoticeHandler={this.toggleNoticeHandler}
                    />
                } */}
                <section className="pf-m-dashboard dnw-section">
                    <MobileSubHeader
                        className="bg-white"
                        returnPage="/me"
                        header={t('profile-sidebar.deposit')}
                        // modalHeader={t('deposit.notice')}
                        // modalHandler={this.toggleNoticeHandler}
                        modalHeader={true}
                        modalHandler={this.props.toggleModal}
                    />
                    <div className="quota-deposit-container">
                            <div className="available-amount-content">
                            <img className="active" src={walletImg["wallet-ico.svg"]} alt="wallet-ico" />
                            <div className="amount-body w-100">
                                    <label>{t("wallet.wallet")}</label>
                                    {this.state.loading ? (
                                            <Skeleton count={1} height={20} />
                                        ) : (
                                    <div className="amount">
                                        {this.state.showNum ? 
                                            <p>
                                            {this.props.currentUser.currency}
                                            <span className="ms-2">
                                                {/* {Intl.NumberFormat("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(this.state.data)} */}
                                                {Intl.NumberFormat("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(wallet)}
                                            </span>
                                            </p>
                                            : 
                                                '*******'} 
                                    <img
                                        className="show-hide-btn"
                                        src={img[`${(!this.state.showNum) ? 'close-' : ''}eye.png`]}
                                        alt="hide pwd"
                                        id="showNum"
                                        name="showNum"
                                        onClick={(event) => this.onInputChangeHandler(event)}
                                    />
                                </div>
                                )}
                            </div>
                        </div>
                        <div className="px-3">
                        <small className="text-danger">
                            <Icon icon="material-symbols:info" /> {t('deposit.note')}
                            </small>
                        </div>
                        </div>
                    <div className="pd-form-m-col my-3">
                        {this.props.loading ? (
                            <div className="input-group-col">
                                <Skeleton count={2} style={{ marginBottom: ".5rem" }} height={180} />
                            </div>
                        ) : (
                            <>
                            <div>
                                    <label className="col-form-label">{t('deposit.deposit-option')}:</label>
                                    {/* {process.env.REACT_APP_ENV === "staging" && this.props.depositEstTime && (
                                        <>
                                            <div className="transfer-duration-label">
                                                {this.props.depositEstTime === "00:00:00" ? (
                                                    <>
                                                     <Icon icon="ant-design:thunderbolt-outlined" />
                                                        {t("deposit.instant-deposit")}
                                                    </> 
                                                ) : (
                                                    <>
                                                        <Icon icon="ic:baseline-alarm" />
                                                        {new Date(date.getMonth() + date.getDate() + "," + this.props.depositEstTime).getSeconds() > 0 ? (
                                                            <>
                                                                {t("deposit.deposit-in", { minute: new Date(date.getMonth() + date.getDate() + "," + this.props.depositEstTime).getSeconds() })} {t("deposit.sec")}
                                                            </>
                                                            ) : (
                                                            <>
                                                                {t("deposit.deposit-in", { minute: new Date(date.getMonth() + date.getDate() + "," + this.props.depositEstTime).getMinutes() })} {t("deposit.minute")}
                                                            </>
                                                        )}
                                                    </>
                                                )
                                                }
                                            </div>
                                        </>
                                    )} */}
                                    <div className="input-group-col">
                                        <div className="form-check-group">

                                            {this.props.transactionChannel.map((val, idx) => {
                                                if (val.dp_status === 1) {
                                                    return (
                                                        <div
                                                            className="form-check form-check-inline four-check"
                                                            onClick={(event) => this.props.optionSelectHandler(event, val.slug, val.id, val.deposit_est_time)}
                                                            key={idx}
                                                        >
                                                            <input
                                                                className="btn-check"
                                                                type="radio"
                                                                name="depositOption"
                                                                id={`deposit${val.slug}`}
                                                                value={val.slug}
                                                                onChange={() => { }}
                                                                checked={this.props.depositOption === val.slug ? true : false}
                                                            />
                                                            <label className="btn form-check-label" htmlFor={`deposit${val.slug}`}>
                                                                <img src={icons[`${val.slug}.svg`]} alt={val.slug} />
                                                                <p>{t(`transaction-channel.${val.slug}`)}</p>
                                                                {/* {process.env.REACT_APP_ENV === "staging" && val.deposit_est_time && (
                                                                <>
                                                                    <div className="transfer-duration">
                                                                    {val.deposit_est_time === "00:00:00" ? (
                                                                        <>
                                                                            <Icon icon="ant-design:thunderbolt-outlined" />
                                                                                {t("deposit.instant")}
                                                                        </>
                                                                        ) : (
                                                                        <>
                                                                            <Icon icon="ic:baseline-alarm" />
                                                                            {new Date(date.getMonth() + date.getDate() + "," + val.deposit_est_time).getSeconds() > 0 ? (
                                                                                <>
                                                                                    {new Date(date.getMonth() + date.getDate() + "," + val.deposit_est_time).getSeconds()} {t("deposit.sec")}
                                                                                </>
                                                                                ) : (
                                                                                <>
                                                                                    {new Date(date.getMonth() + date.getDate() + "," + val.deposit_est_time).getMinutes()} {t("deposit.minute")}
                                                                                </>
                                                                            )}
                                                                        </>
                                                                        )}
                                                                    </div>
                                                                    </>
                                                                )} */}
                                                            </label>
                                                        </div>
                                                    );
                                                }
                                                else {
                                                    return null;
                                                }
                                            })}
                                            </div>
                                    </div>
                                    </div>
                                {/* {this.props.depositOption === 'quick-pay' ? (
                                    <QuickPay
                                        redirectHandler={this.props.redirectHandler}
                                        {...this.props}
                                    />
                                ) : this.props.depositOption === 'bank-transfer' ? (
                                    <BankTransfer
                                        redirectHandler={this.props.redirectHandler}
                                        {...this.props}
                                    />
                                ) : this.props.depositOption === 'e-wallet' ? (
                                    <EWallet
                                        redirectHandler={this.props.redirectHandler}
                                        {...this.props}
                                    />
                                ) : this.props.depositOption === "crypto" ? (
                                    <Crypto
                                        redirectHandler={this.props.redirectHandler}
                                        {...this.props}
                                    />
                                ) : (
                                    <></>
                                )} */}
                                {this.props.depositOption === 'bank-transfer' ? (
                                    <BankTransfer
                                        redirectHandler={this.props.redirectHandler}
                                        {...this.props}
                                    />
                                ) : this.props.depositOption === "crypto" ? (
                                    <Crypto
                                        redirectHandler={this.props.redirectHandler}
                                        {...this.props}
                                    />
                                ) : (
                                    <></>
                                )}
                            </>
                        )}
                    </div>
                </section >
            </Auxiliary >
        );
    }
}

export default (withNamespaces("translation")(MobileDeposit));
